import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { AddRouteMasterComponent } from "./addroutemaster/addroutemaster.component";
import { AddTourProgramComponent } from "./addtourprogram/addtourprogram.component";
import { DCRComponent } from "./dcr/dcr.component";
import { EditRouteListComponent } from "./editroutelist/editroutelist.component";
import { EditTourProgramComponent } from "./edittourprogram/edittourprogram.component";
import { ExpenseStatementComponent } from "./expensestatement/expensestatement.component";
import { AuthGuard } from '../../components/auth/auth-guard.service';

const mainRoutes: Routes = [

    { path: 'expensestatement', canActivate: [AuthGuard], component: ExpenseStatementComponent },
    { path: 'addroutemaster', canActivate: [AuthGuard], component: AddRouteMasterComponent },
    { path: 'editroutelist', canActivate: [AuthGuard], component: EditRouteListComponent },
    { path: 'listtourprogram', canActivate: [AuthGuard], component: AddTourProgramComponent },
    { path: 'edittourprogram', canActivate: [AuthGuard], component: EditTourProgramComponent },
    { path: 'dcr', canActivate: [AuthGuard], component: DCRComponent }

]
@NgModule({
    imports: [RouterModule.forChild(mainRoutes)],
    exports: [RouterModule]
})
export class TransitionRoutingModule {

}